import React from 'react';
import classNames from 'classnames';
import VstComponent from './VstComponent';

import VstMenu from './VstMenu';

class VstLittleHead extends VstComponent {

  constructor() {
    super();
    this._clickLilHead = this._clickLilHead.bind(this);
    this._closeMenu = this._closeMenu.bind(this);
    this.state = {
      menuRight: 0,
      visible: false
    };
  }

  componentDidUpdate() {
    // update the location of the dropdown menu depending on the location of the button
    const menuRight = window.innerWidth - this.refs.lilHeadButton.offsetLeft - this.refs.lilHeadButton.offsetWidth;
    if (menuRight !== this.state.menuRight) {
      // TODO: fix lint error
      /* eslint-disable react/no-did-update-set-state */
      this.setState({ menuRight });
      /* eslint-enable react/no-did-update-set-state */
    }
  }

  _clickLilHead() {
    this.setState({ visible: !this.state.visible });
  }

  _closeMenu() {
    this.setState({ visible: false });
  }

  render() {
    return (
      <li ref="lilHeadButton" id="lil-head-button" className={classNames('lil-head-item', { expanded: this.state.visible })}>
        <button className="vst-no-button"
          onClick={this._clickLilHead}
          aria-expanded={this.state.visible}
        >
          {
            // TODO: fix lint error
            /* eslint-disable no-undef */
          }
          <span className="vst-off-screen">{i18n.t('global-bar.account')}</span>
          { /* eslint-enable no-undef */ }
        </button>
        <VstMenu className="lil-head-menu"
          visible={this.state.visible}
          closeMenu={this._closeMenu}
        >
          {this.props.children}
        </VstMenu>
      </li>
    );
  }

}

export default VstLittleHead;
